import ReactPixel from "react-facebook-pixel";

ReactPixel.init("794378711454098");

export default ReactPixel;
